import React, { useEffect } from 'react'
import emailjs from "emailjs-com";

import aos from "aos";
import "aos/dist/aos.css";
const Contact = () => {

    const sendEmail= (e) =>{
        e.preventDefault();

    emailjs.sendForm('service_2xj8hvm', 'template_2rcgrlj', e.target, 'user_H8d65FHsNcz88WLAcQcKm')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }

    document.title="💻 Contact | Rian Islam"
    useEffect(() => {
        aos.init({ duration: 2000 });
      }, []);
    
    return (
        <div data-aos="fade-up" className="container py-5">
            <div className="row py-5">
                <div className="col-md-2"></div>
                <div className="col-md-8 py-5">
                    <div className=" py-5">
                        <h1 className="pb-4" style={{"borderBottom":"1px solid #ddd"}} >Contact</h1>
                        <h3 className="py-4">
                        {/* <a href="">rianislamrd@gmail.com</a> */}
                        
                        <form onSubmit={sendEmail}>
                    <div className="row pt-5 mx-auto">
                        <div className="col-8 form-group mx-auto">
                            <input type="text" className="form-control" placeholder="Name" name="name"/>
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input type="email" className="form-control" placeholder="Email Address" name="email"/>
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input type="text" className="form-control" placeholder="Subject" name="subject"/>
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <textarea className="form-control" id="" cols="30" rows="8" placeholder="Your message" name="message"></textarea>
                        </div>
                        <div className="col-8 pt-3 mx-auto">
                            <input type="submit" className="btn btn-info" value="Send Message"></input>
                        </div>
                    </div>
                </form>
                        

                        </h3>
                        <p style={{"borderTop":"1px solid #ddd"}} className="pt-4">
                        If you have some query about me.please email me ❤ 
                        </p>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        </div>
    )
}

export default Contact
